import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[currency]',
  standalone: false,
})
export class CurrencyDirective {
  constructor(private readonly ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    const digitsOnly = value.replace(/[^\d]/g, '');

    const formattedValue = digitsOnly.replace(/(\d+?)(\d{2})$/, '$1.$2');

    this.ngControl.control?.setValue(formattedValue);
  }
}
